import _ from 'lodash';
import Immutable from 'immutable';
import Resource, { ResourceApi } from '../../resource/Resource';
import {
  UPDATE_COURSES,
  START_SET_COURSE_OBJECTIVE_AND_OUTCOMES,
  FINISH_SET_COURSE_OBJECTIVE_AND_OUTCOMES,
  CREATE_MODULE_TO_COURSE_MODULE_SET,
  DELETE_MODULE_FROM_COURSE,
  UPDATE_MODULE_DATA,
  COURSE_ADD_ADMIN,
  SET_COURSE_LANDING_PAGE_DATA,
  CREATE_COURSE_START,
  CREATE_COURSE_SUCCESS,
  CREATE_COURSE_FAILURE,
  FETCH_COURSE_MODULES_START,
  FETCH_COURSE_MODULES_SUCCESS,
  FETCH_COURSE_MODULES_FAILURE,
  SET_COURSE_MODULES,
  FETCH_COURSE_SUBSCRIPTION_DATA_START,
  FETCH_COURSE_SUBSCRIPTION_DATA_SUCCESS,
  FETCH_COURSE_SUBSCRIPTION_DATA_FAILURE,
  COURSE_ACCESS_DENIED,
  UPDATE_COURSE_THEME_DATA,
  CURRENT_COURSE_DOM_BLOB_LOADED,
  UPDATE_COURSE_LANGUAGE,
  UPDATE_COURSE_LANGUAGE_START,
  UPDATE_COURSE_LANGUAGE_FAILED,
  UPDATE_COURSE_SECTOR_TYPES_START,
  UPDATE_COURSE_SECTOR_TYPES,
  UPDATE_COURSE_SECTOR_TYPES_FAILED,
  FETCH_ENROLLED_CLASS_DATA_START,
  FETCH_ENROLLED_CLASS_DATA_FAILURE,
  FETCH_ENROLLED_CLASS_DATA_SUCCESS,
  SET_IDENTITY_SESSION_SETTINGS_START,
  SET_IDENTITY_SESSION_SETTINGS_SUCCESS,
  SET_IDENTITY_SESSION_SETTINGS_FAILED,
} from './actions';
import { COURSE } from '../resourceNames';
import { selectCurrentCoursePath } from './selectors';
import { currentCohortPathSelector } from '../Auth/selectors';
import {
  SET_MODULE_PROGRESS_FOR_COURSE,
  START_FETCH_MODULE_PROGRESS_FOR_COURSE,
} from '../ModuleProgress/actions';
import {
  START_FETCH_PROGRESS_PAGE_DATA,
  SET_PROGRESS_PAGE_DATA,
} from '../ProgressPage/actions';
import { progressPageDataHasLoaded } from '../ProgressPage/selectors';
import { selectSubscriptionRequired } from './CourseAccessCheck/selectors';
import { selectQuery } from '../location/selectors.web';
import { ROUTE_INSTITUTION_ADMIN } from '../routeActions';
import { selectCurrentPagePath } from '../Pages/selectors';
import { pageProgressSelector } from '../PageProgress/selectors';
import { SET_PAGE_TRAVERSAL_LINKS } from '../BlockPageUI/actions';
import { selectHasNextPageLink } from '../BlockPageUI/selectors';

export function updateCourses(courses) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_COURSES,
      courses,
    });
  };
}

export function retrieveCourses(coursePaths) {
  return (dispatch) => {
    return Resource.lookup('course', 'resources', {
      initArgsList: coursePaths,
      ignoreMissing: true,
    }).then((courses) => {
      dispatch(updateCourses(Object.values(courses)));
    });
  };
}

export function setCourseObjectiveAndOutcomes(
  coursePath,
  objective,
  outcomes,
  clientOnly = false
) {
  return (dispatch) => {
    dispatch({
      type: START_SET_COURSE_OBJECTIVE_AND_OUTCOMES,
      coursePath,
      objective,
      outcomes,
    });
    const finishSave = (courseSummary) => {
      setTimeout(() => {
        dispatch({
          type: FINISH_SET_COURSE_OBJECTIVE_AND_OUTCOMES,
          coursePath,
          objective: courseSummary.objective,
          outcomes: courseSummary.outcomes,
        });
      }, 300);
    };

    if (clientOnly) {
      finishSave({ objective, outcomes });
    } else {
      Resource.update('course', coursePath, 'setObjectiveAndOutcomes', {
        objective,
        outcomes,
      }).then((courseSummary) => {
        finishSave(courseSummary);
      });
    }
  };
}

export function setCourseModuleOrderById(coursePath, moduleIds) {
  return (dispatch) => {
    dispatch({
      type: SET_COURSE_MODULES,
      coursePath,
      moduleIds,
    });
  };
}

export function setCourseModules(coursePath, moduleIds, resolve, reject) {
  return (dispatch) => {
    Resource.update('course', coursePath, 'setModules', {
      modules: moduleIds,
    })
      .then(() => {
        dispatch(setCourseModuleOrderById(coursePath, moduleIds));
        resolve();
      })
      .fail((result, response) => {
        reject({
          title: 'Error updating module list',
          message: response.reason,
        });
      });
  };
}

export function updateModuleData(coursePath, moduleID, changes) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_MODULE_DATA,
      coursePath,
      moduleID,
      changes,
    });
  };
}

export function createModuleToCourseModuleSet(coursePath, newModule) {
  return (dispatch) => {
    dispatch({
      type: CREATE_MODULE_TO_COURSE_MODULE_SET,
      coursePath,
      newModule,
    });
  };
}

export function deleteModuleFromCourse(coursePath, moduleid, moduleSet) {
  return (dispatch) => {
    dispatch({
      type: DELETE_MODULE_FROM_COURSE,
      coursePath,
      moduleid,
      moduleSet,
    });
  };
}

export function updateModuleBasicData(
  coursePath,
  moduleID,
  module,
  resolve,
  reject
) {
  return (dispatch) => {
    Resource.update('module', moduleID, [
      {
        method: 'setTitle',
        args: {
          title: module.get('title'),
        },
      },
      {
        method: 'setDescription',
        args: {
          description: module.get('description'),
        },
      },
    ])
      .then(() => {
        dispatch(updateModuleData(coursePath, moduleID, module));
        resolve();
      })
      .fail((result, response) => {
        reject({
          title: 'Error updating module data',
          message: response.reason,
        });
      });
  };
}

export function createModuleAndAddtoModuleSet(
  coursePath,
  newModule,
  resolve,
  reject
) {
  return (dispatch) => {
    Resource.update('course', coursePath, 'createModule', {
      title: newModule.get('title'),
      description: newModule.get('description'),
      setName: newModule.get('setName', null),
    })
      .then((result) => {
        dispatch(createModuleToCourseModuleSet(coursePath, result));
        resolve();
      })
      .fail((result, response) => {
        reject({
          title: 'Error creating module',
          message: response.reason,
        });
      });
  };
}

export function deleteModule(coursePath, moduleid, moduleSet, resolve, reject) {
  return (dispatch) => {
    Resource.update('course', coursePath, 'deleteModule', {
      moduleID: moduleid,
    })
      .then(() => {
        dispatch(deleteModuleFromCourse(coursePath, moduleid, moduleSet));
        resolve();
      })
      .fail((result, response) => {
        reject({
          title: 'Error deleting module',
          message: response.reason,
        });
      });
  };
}

export const setCourseThemeData = (coursePath, themeDataChanges) => (
  dispatch
) => {
  return Resource.update(COURSE, coursePath, 'setThemeParams', {
    params: themeDataChanges,
  }).then((themeData) => {
    dispatch({
      type: UPDATE_COURSE_THEME_DATA,
      coursePath,
      themeData,
    });
  });
};

export const setCourseLanguage = (coursePath, language) => (dispatch) => {
  dispatch({
    type: UPDATE_COURSE_LANGUAGE_START,
  });
  return Resource.update(COURSE, coursePath, 'setLanguage', {
    language,
  }).then(
    () => {
      dispatch({
        type: UPDATE_COURSE_LANGUAGE,
        coursePath,
        language,
      });
    },
    (error) => {
      dispatch({
        type: UPDATE_COURSE_LANGUAGE_FAILED,
        error: error.message,
      });
    }
  );
};

export const addCourseAdmin = ({ coursePath, userId }) => (dispatch) =>
  Resource.update(COURSE, coursePath, 'addAdmin', {
    userId,
  }).then(({ enrolment, admins }) =>
    dispatch({
      type: COURSE_ADD_ADMIN,
      coursePath,
      enrolment,
      admins,
    })
  );

export function getCourseLandingPageData(coursePath) {
  return (dispatch) => {
    return Resource.read('course', coursePath, 'getCourseLandingPageData').then(
      ({ course, openCohorts, coursePromoData, portal, users }) => {
        dispatch({
          type: SET_COURSE_LANDING_PAGE_DATA,
          course,
          cohortList: openCohorts || [],
          coursePromoData,
          portal,
          users,
        });
      }
    );
  };
}

export const loadCurrentCourseLandingPageData = (dispatch, getState) => {
  const state = getState();
  const currentCoursePath = selectCurrentCoursePath(state);
  return dispatch(getCourseLandingPageData(currentCoursePath));
};

export const fetchTraversalLinkData = (pagePath, cohortPath) => {
  return (dispatch) => {
    Resource.read('page', pagePath, 'getTraversalLinks', { cohortPath }).done(
      (result) => {
        dispatch({
          type: SET_PAGE_TRAVERSAL_LINKS,
          pagePath,
          traversalLinks: result,
        });
      }
    );
  };
};

export const fetchModuleDisplayData = (coursePath, cohortPath) => {
  return (dispatch, getState) => {
    const state = getState();
    const currentPage = selectCurrentPagePath(state);
    const progress = pageProgressSelector(state).get(
      currentPage,
      Immutable.Map()
    );
    const hasNextPage = selectHasNextPageLink(state);

    dispatch({
      type: START_FETCH_MODULE_PROGRESS_FOR_COURSE,
      coursePath,
    });

    return Resource.read(COURSE, coursePath, [
      'getModuleProgressForUser',
      {
        method: 'getCohortScheduling',
        args: {
          cohortPath,
        },
      },
    ]).then(([{ moduleList }, schedule]) => {
      dispatch({
        type: SET_MODULE_PROGRESS_FOR_COURSE,
        moduleProgress: moduleList,
        coursePath,
        cohortPath,
        schedule,
      });

      const completed = progress.get('completed', 0);
      const total = progress.get('total', 0);
      if (completed === total && !hasNextPage) {
        dispatch(fetchTraversalLinkData(currentPage, cohortPath));
      }
    });
  };
};

export const loadCurrentCourseModuleDisplayData = (dispatch, getState) => {
  const state = getState();
  const coursePath = selectCurrentCoursePath(state);
  const cohortPath = currentCohortPathSelector(state);
  if (coursePath && cohortPath) {
    // skip the resource call if we don't know the coursePath and cohortPath
    // e.g. if we're on a non-course block page
    return dispatch(fetchModuleDisplayData(coursePath, cohortPath));
  } else {
    return Promise.resolve();
  }
};

export const refreshCourseProgressData = _.debounce(
  loadCurrentCourseModuleDisplayData,
  3000
);

export const fetchProgressPageData = (forUser) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({
      type: START_FETCH_PROGRESS_PAGE_DATA,
    });

    const coursePath = selectCurrentCoursePath(state);
    const cohortPath = currentCohortPathSelector(state);

    return Resource.read(COURSE, coursePath, [
      {
        method: 'getModuleProgressForUser',
        args: { forUser },
      },
      {
        method: 'getCohortScheduling',
        args: {
          cohortPath,
        },
      },
    ]).then(([{ moduleList }, cohortSchedule]) => {
      dispatch({
        type: SET_PROGRESS_PAGE_DATA,
        moduleList,
        cohortSchedule,
      });
    });
  };
};

export const loadProgressPageDataForUser = (forUser) => {
  return (dispatch, getState) => {
    if (progressPageDataHasLoaded(getState())) {
      return Promise.resolve();
    }
    return dispatch(fetchProgressPageData(forUser));
  };
};

export const fetchModules = (coursePath) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_COURSE_MODULES_START,
      coursePath,
    });

    return ResourceApi.read(COURSE, coursePath, [
      'getModuleSets',
      'getModulesForEditor',
    ]).then(
      ([{ moduleSetList }, { moduleList }]) => {
        dispatch({
          type: FETCH_COURSE_MODULES_SUCCESS,
          coursePath,
          modules: moduleList,
          moduleSets: moduleSetList,
        });
        return {
          moduleList,
          moduleSetList,
        };
      },
      (err) => {
        dispatch({
          type: FETCH_COURSE_MODULES_FAILURE,
          coursePath,
          error: err.message,
        });
      }
    );
  };
};

export const validateCourseName = (courseName, requestId) => {
  return () => {
    return new Promise((resolve, reject) =>
      Resource.lookup(COURSE, 'validateNewName', { name: courseName }).then(
        ({ path }) =>
          resolve({
            requestId,
            path,
          }),
        () => {
          /* eslint-disable-next-line prefer-promise-reject-errors */
          reject({ requestId });
        }
      )
    );
  };
};

export const validateCourseUrl = (path, institution, requestId) => {
  return () => {
    return new Promise((resolve, reject) =>
      Resource.lookup(COURSE, 'validateNewUrl', { path, institution }).then(
        ({ canUse }) =>
          resolve({
            requestId,
            canUse,
          }),
        () => {
          /* eslint-disable-next-line prefer-promise-reject-errors */
          reject({ requestId });
        }
      )
    );
  };
};

export const createCourse = (courseCreationData) => {
  return (dispatch, getState) => {
    dispatch({
      type: CREATE_COURSE_START,
      ...courseCreationData,
    });

    return ResourceApi.create(COURSE, courseCreationData, ['resource']).then(
      (response) => {
        const course = response[0];
        dispatch({
          type: CREATE_COURSE_SUCCESS,
          course,
        });

        const query = selectQuery(getState()).merge({ tab: 'view-course' });
        dispatch({
          type: ROUTE_INSTITUTION_ADMIN,
          query: query.toJS(),
        });

        return course;
      },
      (error) => {
        const message = error.response ? error.response.message : error.message;
        dispatch({
          type: CREATE_COURSE_FAILURE,
          error: message,
          institutionPath: courseCreationData.institutionPath,
        });

        throw new Error(message);
      }
    );
  };
};

export const loadCurrentCourseSubscriptionData = (dispatch, getState) => {
  const coursePath = selectCurrentCoursePath(getState());

  dispatch({
    type: FETCH_COURSE_SUBSCRIPTION_DATA_START,
  });

  return ResourceApi.read(COURSE, coursePath, 'getCourseSubscriptionData').then(
    ({ courses, user, enrolments, subscriptionPlans }) => {
      dispatch({
        type: FETCH_COURSE_SUBSCRIPTION_DATA_SUCCESS,
        courses,
        user,
        userId: user.id,
        enrolments,
        subscriptionPlans,
      });

      const subscriptionRequiredData = selectSubscriptionRequired(getState());
      if (
        subscriptionRequiredData &&
        subscriptionRequiredData.subscriptionRequired
      ) {
        dispatch({
          type: COURSE_ACCESS_DENIED,
          subscriptionId: subscriptionRequiredData.subscriptionId,
          isLegacyEducator: subscriptionRequiredData.isLegacyEducator,
        });
      }
    },
    () => {
      dispatch({
        type: FETCH_COURSE_SUBSCRIPTION_DATA_FAILURE,
      });
    }
  );
};

export const loadCurrentCourseFromDOM = (course) => {
  return (dispatch) => {
    dispatch({
      type: CURRENT_COURSE_DOM_BLOB_LOADED,
      course,
    });
  };
};

export const setCourseSectorTypes = (coursePath, courseSectorTypes) => (
  dispatch
) => {
  dispatch({
    type: UPDATE_COURSE_SECTOR_TYPES_START,
  });
  return Resource.update(COURSE, coursePath, 'setCourseSectorTypes', {
    courseTypes: courseSectorTypes,
  }).then(
    () => {
      dispatch({
        type: UPDATE_COURSE_SECTOR_TYPES,
        coursePath,
        courseSectorTypes,
      });
    },
    (error) => {
      dispatch({
        type: UPDATE_COURSE_SECTOR_TYPES_FAILED,
        error: error.message,
      });
    }
  );
};

export const getEnrolledClassDataByCoursePath = (coursePath) => {
  return (dispatch) => {
    dispatch({ type: FETCH_ENROLLED_CLASS_DATA_START });
    return Resource.read(
      'course',
      coursePath,
      'getEnrolledClassDataForUser'
    ).then(
      (data) => {
        const { cohorts, course, enrolments, user, creator } = data;

        dispatch({
          type: FETCH_ENROLLED_CLASS_DATA_SUCCESS,
          cohortList: Object.values(cohorts),
          course,
          enrolments,
          user,
          creator,
        });
      },
      (error) => {
        dispatch({ type: FETCH_ENROLLED_CLASS_DATA_FAILURE, error });
      }
    );
  };
};

export const setIdentitySessionSettings = ({
  keystrokeEnabled,
  facialCheckEnabled,
}) => (dispatch, getState) => {
  dispatch({
    type: SET_IDENTITY_SESSION_SETTINGS_START,
  });
  const coursePath = selectCurrentCoursePath(getState());

  return Resource.update(COURSE, coursePath, 'setIdentitySessionSettings', {
    keystrokeEnabled,
    facialCheckEnabled,
  }).then(
    () => {
      dispatch({
        type: SET_IDENTITY_SESSION_SETTINGS_SUCCESS,
        coursePath,
        keystrokeEnabled,
        facialCheckEnabled,
      });
    },
    (error) => {
      dispatch({
        type: SET_IDENTITY_SESSION_SETTINGS_FAILED,
        error: error.message,
      });
    }
  );
};
